import { Filter, OrderByCondition } from "@/types/filter.type";
import { Pagination } from "@/types/pagination.type";

import axios from "./api";
import { responseHandlerDefault } from "./../utils/handler.util";
import { SamplingPointImageStatus } from "@/types/issueMonitoring.type";

export const getSamplingPointsImageStatus = (
  page?: number,
  size?: number,
  filter?: Filter,
  order?: OrderByCondition
): Promise<Pagination<SamplingPointImageStatus>> => {
  const params: {
    page?: number;
    size?: number;
    filter?: Filter;
    order?: OrderByCondition;
  } = {};
  if (page) {
    params.page = page;
  }
  if (size) {
    params.size = size;
  }
  if (filter) {
    params.filter = filter;
  }
  if (order) {
    params.order = order;
  }

  return axios.get(`/samplingpointimagestatus/`, { params }).then(responseHandlerDefault);
};

export const putSamplingPointsImageStatus = (
  entity: SamplingPointImageStatus
): Promise<SamplingPointImageStatus> => {
  return axios
    .put<SamplingPointImageStatus>(`/samplingpointimagestatus/`, entity)
    .then(responseHandlerDefault);
};
